import React from 'react';
import { IProps, IState, IFormValue } from './types';
import { Formik, Form, Field } from 'formik';
import { VerifySecqueReq } from 'bff/models/login';
import service from 'bff/services/loginService';
import { CodeId } from 'constants/enums/codeId.enum';
import commonService from 'utils/commonService';

/**
 * @description 表單初始值設定
 */
const initialVal: IFormValue = {
  secqueAnswer: ''
};

/** 詢問安全問題頁 */
class SecurityQuestion extends React.Component<IProps, IState> {
  state:IState = {}
  shouldComponentUpdate (preProps:IProps, preState:IState) {
    return (preProps.secque?.SECQUE.SECQUE_ID !== this.props.secque?.SECQUE.SECQUE_ID);
  }

  componentDidUpdate () {
    // console.log('SecurityQuestion componentDidUpdate');
  }

  /**
   * @description Form 表單 Submit 事件
  */
  handleFormSubmit = async (values:IFormValue) => {
    const verifySecqueReq: VerifySecqueReq = {
      MEMBER_ID: this.props.memberId,
      SECQUE_ID: this.props.secque?.SECQUE.SECQUE_ID as string,
      SECQUE_ANSWER: values.secqueAnswer
    };

    const result = await service.verifySecque(verifySecqueReq);
    if (result) {
      this.props.onVerifySuccess();
    }
  }

  render () {
    return (
      <div className="security-question auth-block">
        <Formik
          initialValues={initialVal}
          onSubmit={this.handleFormSubmit}
        >
          {(formProps) => (
            <Form>
              <div className="auth-block__row">
                <p className="auth-block__part">{commonService.getCodeMsg(this.props.UICode, CodeId.U012)}</p>
              </div>
              <div className="auth-block__row">
                <div className="element__form-group">
                  <div className="element__form-group-title">{this.props.secque?.SECQUE.SECQUE_QUESTION}</div>
                  <Field type="text" name="secqueAnswer" autoComplete="off" className="element__input" placeholder="請輸入答案" />
                </div>
              </div>
              <div className="auth-block__row">
                <p className="auth-block__desc">{commonService.getCodeMsg(this.props.UICode, CodeId.U013)}</p>
              </div>
              <div className="auth-block__row">
                <button type="submit" className="element__button element__button--red">送出</button>
                <button type="button" className="element__button element__button--black" onClick={this.props.onGoBack}>返回</button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
};

export default SecurityQuestion;
